module.exports = __webpack_public_path__ + "static/media/grafica.642463bf.svg";